export default __webpack_public_path__ + "static/media/a001-whatsapp-01.e30ed6fc.png";